module.exports = __webpack_public_path__ + "static/media/checkradio.03676872.svg";